import {
  Button,
  Message,
  Modal,
} from '@mairistem/composants';
import React from 'react';

interface ProfilEcritureResetModalProps {
  onPress: any;
  open: boolean;
}

const ProfilEcritureResetModal = ({
  onPress,
  open = false,
}: ProfilEcritureResetModalProps) => {
  const handleClick = (e, data) => onPress?.(data?.positive || !data?.negative);

  return (
    <Modal open={open}>
      <Modal.Header content="Changement de profil" />
      <Modal.Content>
        <Message>
          <Message.Header content="Vous venez de changer de profil d'écriture, êtes-vous sûrs de vouloir le faire ?" />
          <p>Cela effacera tous les champs que vous aviez remplis</p>
        </Message>
      </Modal.Content>
      <Modal.Actions>
        <Button
          content="Oui"
          positive
          onClick={handleClick}
        />
        <Button
          content="Non"
          negative
          onClick={handleClick}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ProfilEcritureResetModal;
